import { Directive, Input, ElementRef, OnDestroy } from '@angular/core';
import { Observable, Subscription, ReplaySubject, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from "@angular/cdk/portal";
import { LoaderComponent } from '../shared/components/loader/loader.component';

@Directive({
  selector: '[appLoader]'
})

// can use this directive to insert a loader for table in future
export class LoaderDirective<T> implements OnDestroy {
  overlayRef = this.overlay.create({
    scrollStrategy: this.overlay.scrollStrategies.reposition(),
    positionStrategy: this.overlay.position()
      .flexibleConnectedTo(this.elementRef)
      .withPush(false)
      .withPositions(
          [
              {
                  originX: "center",
                  originY: "center",
                  overlayX: "center",
                  overlayY: "center"
              }
          ]
      ),
    hasBackdrop: true
  })

  private destroy$ = new ReplaySubject<void>(1);
  currentSubscription: Subscription | undefined

  @Input()
  set appOverlayLoader(value: Observable<T>) {
      //causes the subscription to be called twice, once in the component and second time here
      //so ReplaySubject is used to emit the old values back to mitigate the issue.
    this.showLoader();
    of(value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.hideLoader(),
        complete: () => this.hideLoader(),
        error: () => this.hideLoader()
      });
  };

  constructor(
      private elementRef: ElementRef,
      private overlay: Overlay,
  ) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private showLoader() {
      this.overlayRef.attach(new ComponentPortal(LoaderComponent))
  }

  private hideLoader() {
      this.overlayRef.detach()
  }
}
